<script lang="ts" module>
  interface ProductRecommendationSliderProps {
    title: string;
    products: ProductVariant[];
    css?: SystemStyleObject;
    ignoreDrawer?: boolean;
  }
</script>

<script lang="ts">
  import type { ProductVariant } from '@agapi/mlc-core';
  import type { SystemStyleObject } from '@agapi/ui/panda/types';
  import { css } from '@agapi/ui/panda/css';
  import { Carousel, CarouselSlide } from '@agapi/ui/carousel';

  import { ProductCard } from '../';
  import { productRecommendationSliderStyles } from './product-recommendation-slider.styles';

  import * as m from '$lib/parachute/messages'

  const { title, products, css: cssProp, ignoreDrawer }: ProductRecommendationSliderProps = $props();

  const classes = productRecommendationSliderStyles.raw({});
</script>

{#if products.length > 0}
<div class={css(classes.container, cssProp)}>
  <h2 class={css(classes.title)}>{title}</h2>
  <Carousel
    css={{ gap: '4' }}
    options={{
      align: 'start',
      slidesToScroll: 3,
      breakpoints: {
        '(max-width: 768px)': {
          slidesToScroll: 1
        }
      }
    }}
  >
    {#each products as variant}
      <CarouselSlide>
        <div class={css(classes.product)}>
          <ProductCard.Medium
            ignoreDrawer={ignoreDrawer}
            css={{
              minWidth: { base: '100%', lg: '40%' }
            }}
            product={variant}
            buttonLabel={m.buy()}
          />
        </div>
      </CarouselSlide>
    {/each}
    </Carousel>
  </div>
{/if}
